/**
 * @module Products
 * @description Utils for Products
 */

/**
 * @function splitPrice
 * @description Split the price up into dollars and cents
 */
export const splitPrice = ( price: string, type = 'dollars' ) => {
  if ( ! price ) {
    return;
  }

  const pricing = price.toString().split( '.' );

  if ( type === 'cents' ) {
    return pricing[ 1 ];
  }

  return pricing[ 0 ];
};

export const stripCurrency = ( price: any ) => {
  if ( ! price ) return;

  if ( price[ 0 ] === '$' ) {
    return price.substring( 1 );
  }

  return price;
};
